<template>
  <span :class="classes">
    {{ status }}
  </span>
</template>

<script>
export default {
  name: 'StatusIndicator',
  props: ['status'],
  computed: {
    classes() {
      switch (this.status) {
        case 'OFFLINE':
          return 'has-text-grey-dark'
        case 'STANDBY':
          return 'has-text-danger'
        case 'processing':
          return 'has-text-grey'
        case 'stopped':
          return 'has-text-danger'
        default:
          return 'has-text-success'
      }
    }
  }
}
</script>

<style scoped></style>
